export const PLEASE_SELECT_ONE = "Please Select One";
export const NUMBER_ONLY_REGEX = /[^0-9]/g;
export const BEGIN_DATE_SHOULD_NOT_BE_LESS_THAN_1964 = 'Begin Date should be greater than or equals to 01/01/1964';
export const DATE_ERROR_1964 = 'Date must be greater than or equal to 01/01/1964.';
export const ERR_PROCESSING_REQ = 'There was an error processing the request. Please retry the transaction.';
//
export const HELP = 'Help';
export const HISTORY = 'History';
export const NOTES = 'Notes';
export const PRINT = 'Print';
export const SAVE = 'Save';
export const SAVE_SUCCESS = 'System successfully saved the Information.';
export const FINANCIAL = 'Financial';
export const CMdSPortals = "Turquoise-Portals";
export const CLAIMS_APP_CODE='CLAIMS'
export const X_CMDS_APP_CODE = 'CNDTAPPS_V2';
export const MANAGEACCOUNT_APP_ID = 'MANAGEACCOUNT';
export const MANAGEACCOUNTR_APP_ID = 'MANAGEACCOUNTR';
export const EMAIL_MAXLENGTH = 256;
export const PASSWORD_LIMIT = 30;
export const SELECT_ORG = 'Select-Organization';
export const CMDS_LAST_ACTIVITY_TS = 'cmds_last_activity_ts';
export const CMDS_SESSION_TIMEOUT_MINUTES = 'cmds_session_timeout_minutes';
export const GLOBAL_SESSION_TIMEOUT_MESSAGE = 'globalSessionTimeout';
export const GLOBAL_SESSION_TIMEOUT_WARNING_MESSAGE = 'globalSessionTimeoutWarning';
export const GLOBAL_SESSION_TIMEOUT_WARNING_DISMISSED = 'globalSessionTimeoutWarningDismissed';
export const GLOBAL_SESSION_TIMEOUT_STAY_SIGNED_IN = 'globalSessionTimeoutStaySignedIn';
export const USER_REQUESTED_LOGOUT = 'userRequestedLogout';
export const CMDS_SESSION_IFRAME_ID = 'cmds-session-timeout-iframe';
export const SESSION_EXPIRY_MSG =
  'Your session is about to expire. Do you want to continue with this session?';